<template>
  <div class="grid dashboard">
    <div class="col-12">
      <div class="card">
        <DataTable
          v-if="productos && productos.length > 0"
          :value="productos"
          :loading="loading"
          :lazy="true"
          :paginator="true"
          :rows="tamPagina"
          :totalRecords="totalRecords"
          class="p-datatable-responsive"
          :selection.sync="selectedProducto"
          selectionMode="single"
          dataKey="id"
          @page="onPage($event)"
          @row-select="onRowClick"
          @row-unselect="onRowClick(null)"
          :expandedRows.sync="expandedRows"
        >
          <template #header>
            <div class="table-header">
              {{ tituloHeader ? tituloHeader : $t("producto.titulo.listado") }}
            </div>
          </template>

          <template #empty>
            {{ $t("common.noResultados") }}
          </template>

          <Column :expander="true" headerStyle="width: 3em">
            <template #header>
              <button
                class="p-row-toggler p-link center"
                @click="expandOrCollapse()"
              >
                <span :class="expandClass"></span>
              </button>
            </template>
          </Column>

          <Column
            :header="$t('common.campos.seleccionar')"
            filterMatchMode="equals"
          >
            <template #body="slotProps">
              <Button
                type="button"
                :icon="obtenerIconoAccion(slotProps.data)"
                :class="obtenerClaseIconoAccion(slotProps.data)"
                style="margin-right: 0.5em"
                @click="handleOnActionButtonClick(slotProps)"
              ></Button>
            </template>
          </Column>



          <Column
            field="producto.nombreProducto"
            :header="$t('producto.nombreProducto')"
            :sortable="false"
          >
            <template #body="slotProps">
              {{ 
                slotProps.data.tipoProducto 
                ?
                slotProps.data.tipoProducto.nombre  
                :
                '' 
              }}
              
            </template>
            
          </Column>
          

          <Column
            field="producto.tipoServicio"
            :header="$t('producto.tipoServicio')"
            :sortable="false"
          >
            <template #body="slotProps">
              {{ slotProps.data.literalProductoTipo 
                
              ?
              slotProps.data.literalProductoTipo  
              :
              slotProps.data.literalTipoServicio.valor
               }}
            </template>
          </Column>

          <Column
            field="producto.fechaAlta"
            :header="$t('producto.fechaAlta')"
            :sortable="false"
          >
            <template #body="slotProps">
              {{ getFormattedDateShort(slotProps.data.fechaAlta) }}
            </template>
          </Column>

          <Column
            field="producto.contrato.fechaInicio"
            :header="$t('producto.fechaInicioContrato')"
            :sortable="false"
          >
            <template #body="slotProps">
              {{ getFormattedDateShort(slotProps.data.contrato.fechaInicio) }}
            </template>
          </Column>

          <Column
            field="producto.contrato.fechaFin"
            :header="$t('producto.fechaFinContrato')"
            :sortable="false"
          >
            <template #body="slotProps">
              {{ getFormattedDateShort(slotProps.data.contrato.fechaFin) }}
            </template>
          </Column>

          <template #expansion="slotProps">
            <div
              v-if="
                slotProps.data.promociones &&
                slotProps.data.promociones.length > 0
              "
            >
              <DataTable
                :value="slotProps.data.promociones"
                class="
                  p-datatable-responsive
                  tableExpansion
                  promocionesDatatable
                "
              >
                <Column
                  field="nombre"
                  :header="$t('promocion.nombre')"
                  :sortable="false"
                >
                  <template #body="slotProps">
                    <span class="p-column-title">{{
                      $t("promocion.nombre")
                    }}</span>
                    <template>
                      {{ slotProps.data.nombre }}
                    </template>
                  </template>
                </Column>

                <Column
                  field="tipo"
                  :header="$t('promocion.tipo')"
                  :sortable="false"
                >
                  <template #body="slotProps">
                    <template>
                      {{ slotProps.data.literalTipoPromocion.valor }}
                    </template>
                  </template>
                </Column>

                <Column
                  field="contadorUsos"
                  :header="$t('promocion.contadorUsos')"
                  :sortable="false"
                >
                  <template #body="slotProps">
                    <template>
                      {{ slotProps.data.contadorUsos }}
                    </template>
                  </template>
                </Column>

                <Column
                  field="numeroUsos"
                  :header="$t('promocion.numeroUsos')"
                  :sortable="false"
                >
                  <template #body="slotProps">
                    <template>
                      {{
                        slotProps.data.numeroUsos
                          ? slotProps.data.numeroUsos
                          : 0
                      }}
                    </template>
                  </template>
                </Column>
              </DataTable>
            </div>
          </template>
        </DataTable>
        <div v-else>
          <p>{{ $t("producto.noHayContratos") }}</p>
          <a
            href="https://iciredimpagados.com/contacto/comercial/"
            >{{ $t("producto.masInformacion") }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import DatesMixin from "@/utils/dates";
import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import { GET_PRODUCTOS_BY_IDLEGAL_CLIENTE_AND_TIPO_ICIRED } from "@/graphQLQueries/ProductoQueries";
import TablesMixin from "@/utils/tables";
import { TIPOS_CONTRATOS_INCOMPATIBLES_ALTA_OPERACION } from "@/resources/constants";

export default {
  name: "ListadoProductos",
  mixins: [DatesMixin, StringsMixin, UsersMixin, TablesMixin],
  props: {
    idLegalCliente: { type: String },
    selectedProductoValue: { type: Object },
    tituloHeader: { type: String },
    tipo: { type: String, default: '' }
  },
  data() {
    return {
      numPagina: 0,
      tamPagina: 10,
      sort: ["-id"],
      loading: true,
      totalRecords: 0,
      selectedProducto: this.selectedProductoValue,
      expandedRows: [],
      expandClass:
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right",
      tiposContratoIncompatibles: TIPOS_CONTRATOS_INCOMPATIBLES_ALTA_OPERACION,
    };
  },
  methods: {
    onPage(event) {
      this.numPagina = event.page;
    },
    onRowClick(event) {
      const producto = event ? event.data : null;

      this.publishOnProductoClickEvent(producto);
    },
    publishOnProductoClickEvent(producto) {
      this.$emit("producto-click", producto);
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass =
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";
      this.expandedRows = this.productos.filter(
        (p) => p.promociones && p.promociones.length > 0
      );
    },
    mapProductos(productos) {
      return productos
        .filter ((producto) => 
          producto.contrato.estado === "ACTIVO")
        // .filter((producto) =>
        //   this.esBusqueda
        //     ? producto.tipoProducto.busqueda
        //     : !producto.tipoProducto.busqueda
        // )
        .filter(
          (producto) => new Date() <= moment(new Date(producto.contrato.fechaFin)).endOf("day").toDate()
        )
        .map((producto) => {
          if (producto.promociones.length > 0) {
            producto.promociones = this.getPromocionesConUsosPendientes(producto.promociones);
          }
          if (producto.promociones.length === 0 && producto.literalTipoServicio.clave === "A_EXITO"){
            producto.promociones = [{
              id: -1,
              nombre: "A exito",
              literalTipoPromocion: producto.literalTipoServicio,
              contadorUsos: 0,
              numeroUsos: 9999,
              fechaAlta: producto.fechaAlta
            }]
          }
          if (producto.combinado){
            producto.promociones = this.getCombinadoConUsosPendientes(producto.combinado);
          }
          
          return producto;
        })
        .filter ((producto) => producto.promociones && producto.promociones.length > 0);
    },
    getPromocionesConUsosPendientes(promociones){
      const promocionesUsadas = promociones
          .filter((p) => !p.numeroUsos || p.contadorUsos == p.numeroUsos)
          .map((p) => {
              p.usosPendientes = false;
              return p;
          })
          .sort((p1, p2) => {
              return new Date(p1.fechaAlta) - new Date(p2.fechaAlta);
          })
          .reverse();

      let promocionUsadaMasNueva = promocionesUsadas && promocionesUsadas.length > 0
              ? promocionesUsadas[0]
              : null;

      let promocionesConUsosPendientes = promociones
          .filter((p) => p.numeroUsos && p.contadorUsos != p.numeroUsos)
          .map((p) => {
              p.usosPendientes = true;
              return p;
          });
      if (promocionUsadaMasNueva)
            promocionesConUsosPendientes = promocionesConUsosPendientes.concat(
              promocionUsadaMasNueva
            );
      return promocionesConUsosPendientes.map((p) =>{
        p.tipo = 'PROMOCION';
        return p;
      });
    },
    getCombinadoConUsosPendientes(combinado){
      const combi = combinado;
      if (combi.numeroUsos === combi.contadorUsos){
        combi.usosPendientes = false;
      }else {
        combi.usosPendientes = true;
      }
      combi.literalTipoPromocion = combi.literalTipoCombinado;
      combi.tipo= 'COMBINADO';
      return [combi];

    },
    collapseAll() {
      this.expandClass =
        "p-column-title p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
      this.expandedRows = [];
    },
    obtenerIconoAccion(data) {
      return this.selectedProducto && this.selectedProducto.id === data.id
        ? this.actions.selected.icon
        : this.actions.unselected.icon;
    },
    obtenerClaseIconoAccion(data) {
      return this.selectedProducto && this.selectedProducto.id === data.id
        ? this.actions.selected.buttonClass
        : this.actions.unselected.buttonClass;
    },
    handleOnActionButtonClick(slotProps) {
      this.selectedProducto && this.selectedProducto.id === slotProps.data.id
        ? this.onProductoButtonClick()
        : this.onProductoButtonClick(slotProps.data);
    },
    onProductoButtonClick(data) {
      this.selectedProducto = data;
      this.publishOnProductoClickEvent(data);
    },
  },
  apollo: {
    productos: {
      query: GET_PRODUCTOS_BY_IDLEGAL_CLIENTE_AND_TIPO_ICIRED,
      fetchPolicy: "no-cache",
      variables() {
        return {
          id: this.idLegalCliente,
          tipo: this.tipo,
          idioma: this.$i18n.locale,
        };
      },
      update(data) {
        this.loading = false;
        let productos = data.productosIciredPorTipo;

        
        if (!productos) return [];

        productos = this.mapProductos(productos);
        this.totalRecords = productos.length;

        if (this.totalRecords === 1) {
          this.selectedProducto = productos[0];
          this.publishOnProductoClickEvent(this.selectedProducto);
        }

        return productos;
      }
    }
  },
};
</script>